document.addEventListener('DOMContentLoaded', function() {
  function removeEveyFields(root = document) {
    try {
      root.querySelectorAll('*').forEach(el => {
        el.childNodes.forEach(n => {
          if (n.nodeType === 3 && n.textContent && n.textContent.trim().toLowerCase().includes('_evey:')) {
            if (n.previousSibling && n.previousSibling.nodeType === 1 && n.previousSibling.tagName === 'BR') {
              n.previousSibling.remove();
            }
            n.remove();
          }
        });
      });
    } catch (err) {
      console.warn('Evey cleanup error:', err);
    }
  }

  function cleanup() {
    removeEveyFields(document);
  }

  // Initial cleanup
  cleanup();

  // Observe DOM changes for dynamic carts/drawers
  try {
    const observer = new MutationObserver(() => cleanup());
    observer.observe(document.body, { childList: true, subtree: true });
  } catch (err) {
    console.warn('Evey observer failed:', err);
  }

  // Re-run on Shopify cart-related events
  ['shopify:section:load', 'cart:updated', 'cart:drawer:open'].forEach(evt => {
    window.addEventListener(evt, () => setTimeout(cleanup, 100));
  });
});